// extracted by mini-css-extract-plugin
export default {"overview":"R1QlH6THmnRnGNGIs1uP","attributeList":"WF0vTCTwbIah5bvy4Y6c"};